import { Util } from "@grandvisionhq/forms";
import { RESET_STORE, RESET_EXPRESS_CHECKOUT, RESET_SERVICE_STORE_VALIDATION, SET_SERVICE_STORE_VALIDATION, RESET_MY_ACCOUNT_VALIDATION, SET_MY_ACCOUNT_VALIDATION, MARK_FIELDS_TOUCHED, UPDATE_SHIPPING_FORMS, UPDATE_SHIPPING_DETAILS, TOGGLE_EXPRESS_CHECKOUT, TOGGLE_INVOICE, TOGGLE_IS_COMPANY, TOGGLE_DELIVERY_ADDRESS, TOGGLE_CONSENT, SET_CONSENTS, SELECT_PICKUP_POINT, SELECT_SERVICE_STORE, SELECT_STORE, SELECT_SHIPPING_METHOD } from "./actions.js";
const { markFormFieldsTouched } = Util;
const initialFormState = {
  formData: {},
  isEnabled: true,
  isValid: false
};
const initialState = {
  selectedShippingMethod: {
    method: void 0,
    isValid: false,
    isTouched: false
  },
  isBillingAndDeliveryAddressSame: false,
  shippingDetails: {
    billingAddress: initialFormState,
    contactDetails: initialFormState,
    expressCheckout: {
      ...initialFormState,
      isEnabled: false
    },
    invoice: {
      ...initialFormState,
      isEnabled: false
    },
    deliveryAddress: {
      ...initialFormState,
      isEnabled: false
    },
    company: {
      ...initialFormState,
      isEnabled: false
    }
  },
  isPrefillFinished: false,
  consents: []
};
function shippingReducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_SHIPPING_METHOD:
      const { shippingMethod } = action.payload;
      return {
        ...state,
        selectedShippingMethod: {
          method: shippingMethod.method,
          isValid: shippingMethod.isValid,
          isTouched: shippingMethod.isTouched
        }
      };
    case SELECT_STORE:
      const { store } = action.payload;
      return { ...state, selectedStore: store };
    case SELECT_SERVICE_STORE:
      const { serviceStore } = action.payload;
      return { ...state, serviceStore };
    case SELECT_PICKUP_POINT:
      const { pickupPoint } = action.payload;
      return { ...state, selectedPickupPoint: pickupPoint };
    case SET_CONSENTS: {
      const { consents } = action.payload;
      return {
        ...state,
        consents
      };
    }
    case TOGGLE_CONSENT: {
      const { consents } = action.payload;
      const newConsents = state.consents.map((consent) => ({
        ...consent,
        isChecked: consents.includes(consent.value)
      }));
      return {
        ...state,
        consents: newConsents
      };
    }
    case TOGGLE_DELIVERY_ADDRESS: {
      const { enabled } = action.payload;
      return {
        ...state,
        isBillingAndDeliveryAddressSame: !enabled,
        shippingDetails: {
          ...state.shippingDetails,
          deliveryAddress: {
            ...state.shippingDetails.deliveryAddress,
            isEnabled: enabled
          }
        }
      };
    }
    case TOGGLE_IS_COMPANY: {
      const { enabled } = action.payload;
      return {
        ...state,
        shippingDetails: {
          ...state.shippingDetails,
          company: {
            ...state.shippingDetails.company,
            isEnabled: enabled
          }
        }
      };
    }
    case TOGGLE_INVOICE: {
      const { enabled } = action.payload;
      return {
        ...state,
        shippingDetails: {
          ...state.shippingDetails,
          invoice: {
            ...state.shippingDetails.invoice,
            isEnabled: enabled
          }
        }
      };
    }
    case TOGGLE_EXPRESS_CHECKOUT: {
      const { enabled } = action.payload;
      return {
        ...state,
        shippingDetails: {
          ...state.shippingDetails,
          expressCheckout: {
            ...state.shippingDetails.expressCheckout,
            isEnabled: enabled
          }
        }
      };
    }
    case UPDATE_SHIPPING_DETAILS:
      const { formName, formState, formValid } = action.payload.form;
      return {
        ...state,
        shippingDetails: {
          ...state.shippingDetails,
          [formName]: {
            ...state.shippingDetails[formName],
            formData: { ...formState },
            isValid: formValid
          }
        }
      };
    case UPDATE_SHIPPING_FORMS:
      return {
        ...state,
        isPrefillFinished: true,
        shippingDetails: {
          ...state.shippingDetails,
          billingAddress: {
            ...state.shippingDetails.billingAddress,
            ...action.payload.billingAddress
          },
          deliveryAddress: {
            ...state.shippingDetails.deliveryAddress,
            ...action.payload.deliveryAddress
          },
          contactDetails: {
            ...state.shippingDetails.contactDetails,
            ...action.payload.contactDetails
          },
          invoice: {
            ...state.shippingDetails.invoice,
            ...action.payload.invoice
          },
          expressCheckout: {
            ...state.shippingDetails.expressCheckout,
            ...action.payload.expressCheckout
          }
        }
      };
    case MARK_FIELDS_TOUCHED: {
      return {
        ...state,
        selectedShippingMethod: {
          ...state.selectedShippingMethod,
          isTouched: true
        },
        shippingDetails: {
          ...state.shippingDetails,
          deliveryAddress: {
            ...state.shippingDetails.deliveryAddress,
            formData: markFormFieldsTouched(state.shippingDetails.deliveryAddress.formData)
          },
          billingAddress: {
            ...state.shippingDetails.billingAddress,
            formData: markFormFieldsTouched(state.shippingDetails.billingAddress.formData)
          },
          contactDetails: {
            ...state.shippingDetails.contactDetails,
            formData: markFormFieldsTouched(state.shippingDetails.contactDetails.formData)
          },
          invoice: {
            ...state.shippingDetails.invoice,
            formData: markFormFieldsTouched(state.shippingDetails.invoice.formData)
          },
          company: {
            ...state.shippingDetails.company,
            formData: markFormFieldsTouched(state.shippingDetails.company.formData)
          },
          expressCheckout: {
            ...state.shippingDetails.expressCheckout,
            formData: markFormFieldsTouched(state.shippingDetails.expressCheckout.formData)
          }
        },
        consents: state.consents.map((consent) => ({
          ...consent,
          shouldValidate: !!consent.required
        }))
      };
    }
    case SET_MY_ACCOUNT_VALIDATION: {
      return {
        ...state,
        shouldValidateMyAccount: true
      };
    }
    case RESET_MY_ACCOUNT_VALIDATION: {
      return {
        ...state,
        shouldValidateMyAccount: false
      };
    }
    case SET_SERVICE_STORE_VALIDATION: {
      return {
        ...state,
        shouldValidateServiceStore: true
      };
    }
    case RESET_SERVICE_STORE_VALIDATION: {
      return {
        ...state,
        shouldValidateServiceStore: false
      };
    }
    case RESET_EXPRESS_CHECKOUT: {
      return {
        ...state,
        selectedShippingMethod: {
          method: void 0,
          isValid: false,
          isTouched: false
        },
        shippingDetails: {
          ...state.shippingDetails,
          expressCheckout: {
            ...initialFormState,
            isEnabled: false
          }
        },
        consents: []
      };
    }
    case RESET_STORE: {
      return {
        ...state,
        selectedStore: void 0,
        serviceStore: void 0
      };
    }
    default:
      return state;
  }
}
export {
  shippingReducer as default,
  initialFormState,
  initialState
};
//# sourceMappingURL=reducer.js.map
